/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { Typography, Checkbox, Link } from '@one-thd/sui-atomic-components';
import {
  IReturnShipments,
  setUpdatedShipmentFields,
} from '@src/stores/returnStore';
import { formatPhoneNumber } from '@src/utils/general';
import { ItemToReturn } from '../../models/returns';
import ReturnReviewCard from '../shared/summary-cards/ReturnReviewCard';
import ReviewItemDetails from './ReviewItemDetails';
import LORPContactDetails from '../lorp/lorp-contact-details/LORPContactDetails';
import TermsAndConditionsDrawer from './user-acknowledge/TermsAndConditionsDrawer';
import { PhoneNumberDrawer } from '../lorp/PhoneNumberDrawer';
import { ILORPContactDetails } from '../lorp/lorp-contact-details/LORPContactDetailsStep';

interface LORPCardProps {
  items: ItemToReturn[];
  shipment: IReturnShipments;
  onEditItemSubmit: (
    startingState: ItemToReturn,
    closeDrawer: () => void,
  ) => void;
  onRemoveItemSubmit: (selectedItemId: string) => void;
  isPolicyValidatorLoading: boolean;
}

// TODO: Dead code — LORPCard is only reachable via ReturnDetailCard, which exclusively receives
// non-LORP shipments (sortedNonLorpReturnShipments). LORP is handled by LORPGroupedReturnDetailCard.
export const LORPCard = ({
  items,
  shipment,
  onEditItemSubmit,
  onRemoveItemSubmit,
  isPolicyValidatorLoading,
}: LORPCardProps) => {
  const [displayTermsDrawer, setDisplayTermsDrawer] = useState(false);
  const [displayPhoneDrawer, setDisplayPhoneDrawer] = useState(false);
  const { shipmentId, hasAgreed, lorpContactDetails } = shipment;

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    // Update checkmark status for selected shipment
    setUpdatedShipmentFields([shipmentId], {
      hasAgreed: checked,
    });
  };

  const acceptTermsBtnClick = () => {
    setUpdatedShipmentFields([shipmentId], {
      hasAgreed: true,
    });
  };

  const openTermsAndConditions = () => {
    setDisplayTermsDrawer(true);
  };

  const updateContactDetails = (updatedContactDetails: ILORPContactDetails) =>
    setUpdatedShipmentFields([shipmentId], {
      lorpContactDetails: updatedContactDetails,
    });
  const handlePhoneSave = (phoneNumber: string) =>
    updateContactDetails({
      ...lorpContactDetails,
      phoneNumber,
    });

  return (
    <ReturnReviewCard header="Return Pickup">
      {/* Items List */}
      <div className="sui-space-y-6">
        {items.map((item, index) => (
          <div
            key={`${item.lineItemId}-${index}`}
            className="sui-flex sui-items-start sui-gap-4"
          >
            <ReviewItemDetails
              item={item}
              index={index}
              onEditItemSubmit={onEditItemSubmit}
              onRemoveItemSubmit={onRemoveItemSubmit}
              isPolicyValidatorLoading={isPolicyValidatorLoading}
              key={`${item.lineItemId}-${index}`}
            />
          </div>
        ))}
      </div>

      <LORPContactDetails
        contactDetails={lorpContactDetails}
        setDisplayPhoneDrawer={setDisplayPhoneDrawer}
      />

      {/* Terms and Conditions Checkbox */}
      <div className="sui-mt-6">
        <hr />
        <div className="sui-flex sui-mt-6">
          <div className="sui-flex sui-items-center">
            <Checkbox
              id={`lorp-agreement-${shipmentId}`}
              checked={hasAgreed ?? false}
              onChange={handleCheckboxChange}
              inputAttributes={{
                'aria-label': 'lorp-agreement-checkbox',
              }}
            />
            <Typography height="tight">
              <label
                htmlFor={`lorp-agreement-${shipmentId}`}
                className="sui-text-sm sui-leading-5 sui-cursor-pointer"
              >
                I have read and acknowledge the terms and conditions.
              </label>
            </Typography>
          </div>
          <div className="sui-ml-auto">
            <Link onClick={openTermsAndConditions}>View</Link>
          </div>
        </div>
      </div>
      <TermsAndConditionsDrawer
        closeDrawer={() => setDisplayTermsDrawer(false)}
        displayDrawer={displayTermsDrawer}
        acceptTerms={acceptTermsBtnClick}
      />
      <PhoneNumberDrawer
        open={displayPhoneDrawer}
        onClose={() => setDisplayPhoneDrawer(false)}
        onSave={handlePhoneSave}
        initialPhoneNumber={formatPhoneNumber(lorpContactDetails?.phoneNumber)}
      />
    </ReturnReviewCard>
  );
};
